import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  CitySelect,
  GuestsSelector,
  DateSelector
} from '../index';

import {
  MobileFilterPanel
} from '../../components/index';

import {
  ParamsLine,
  ParamsContainer,
  OptionsList,
  OptionsItem,
  CheckboxList,
} from './styles';

class HotelParamsLineMobile extends Component {
  static propTypes = {
    total: PropTypes.number,
    loading: PropTypes.bool,
  };

  static CheckboxList = CheckboxList;

  state = {
    currentDropdown: null,
  };

  handleDropdownClick = evt => {
    const { target } = evt;
    const dropdownName = target.name;

    this.setState(prevState => ({
      currentDropdown: prevState.currentDropdown === dropdownName ? null : dropdownName,
    }));
  };

  handleCloseDropdown = () => {
    this.setState({
      currentDropdown: null,
    });
  };

  render() {
    const { currentDropdown } = this.state;
    const { total, loading } = this.props;

    return (
      <ParamsLine>
        <ParamsContainer>
          <OptionsList>
            <OptionsItem>
              <CitySelect compact shouldFormQueryParams />
            </OptionsItem>
            <OptionsItem>
              <DateSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} total={total}  />
            </OptionsItem>
            <OptionsItem>
              <GuestsSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} total={total} />
            </OptionsItem>
          </OptionsList>
        </ParamsContainer>
        <MobileFilterPanel total={total} loading={loading} />
      </ParamsLine>
    );
  }
}

export default HotelParamsLineMobile;
